import { takeLatest, put, call, fork } from "redux-saga/effects";
import { CompanyService } from "services";
import { message } from "antd";
import {
    fetchedCompanyProfile,
    failedFetchCompanyProfile,
    updatedCompanyProfile,
    failedUpdateCompanyProfile,
    updatedCompanyAddresses,
    failedUpdateCompanyAddresses,
    updatedCompanyAddress,
    failedUpdateCompanyAddress,
    updatedCompanyAssociates,
    failedUpdateCompanyAssociates,
    updatedCompanyBankAccounts,
    failedUpdateCompanyBankAccounts,
    updatedCompanyAssociatesCibil,
    failedUpdateCompanyAssociatesCibil,
    updatedCompanySingleAssociate,
    failedUpdateCompanySingleAssociate,
    updatedCompanyMultipleAssociate,
    failedUpdateCompanyMultipleAssociate,
    updatedCompanySingleAddress,
    failedUpdateCompanySingleAddress,
    updateCompanySingleAddress,
    attachDocument,
    fetchCompanyProfile,
    fetchApplicantsList,
    fetchedCompanyGstinFillingDetails,
    failedFetchCompanyGstinFillingDetails,
    refreshedCompanyGstinFillingDetails,
    failedRefreshCompanyGstinFillingDetails,
    updatedCompanySingleBankAccount,
    failedUpdateCompanySingleBankAccount,
    fetchCaseDetail,
    addCaseAssociates,
    fetchedCompanyChecklist,
    failedFetchCompanyChecklist,
    updatedMpaDetails,
    failedUpdateMpaDetails,
    fetchedCompanyAllMpa,
    failedFetchCompanyAllMpa,
    fetchedEnums,
    failedFetchEnums,
    fetchCompanyAssociatesV2 as fetchCompanyAssociatesV2Action
} from "store/actions";

import { COMPANY_ACTIONS } from "constants/actions";
import { deleteCaseAssociates, failedCreateCompanyNotes, failedFetchCompanyNotes, failedFetchPanAadharLink, fetchedCompanyAssociatesV2, fetchedCompanyNotes, fetchedCreateCompanyNotes, fetchedPanAadharLink } from "../actions";
//Update profile related details like basic profile and cibil
function* fetchCompanyProfileHandler({ payload: { companyId, caseId } }) {
    try {
        const { data, error } = yield call(
            CompanyService.getCompanyProfile,
            companyId,
            caseId
        );
        if (!error) {
            yield put(fetchedCompanyProfile(companyId, data));
        } else {
            yield put(failedFetchCompanyProfile(companyId, error));
        }
    } catch (error) {
        yield put(failedFetchCompanyProfile(companyId, error));
    }
}

function* updateCompanyProfile({ payload: { companyId, profile } }) {
    try {
        const { data, error } = yield call(
            CompanyService.updateCompanyProfile,
            companyId,
            profile
        );
        if (!error) {
            yield put(updatedCompanyProfile(companyId, data));
            message.success("Company Details Updated");
        } else {
            yield put(failedUpdateCompanyProfile(companyId, error));
            message.error("Failed to Update Company Details");
        }
    } catch (error) {
        yield put(failedUpdateCompanyProfile(companyId, error));
        message.error("Failed to Update Company Details");
    }
}

function* updateCompanyAssociates({
    payload: { companyId, associates, addresses, caseId , action  , associateID}
}) {
    try {
        if(action == "delete"){
            const { data, error: fetchError } = yield call(
                CompanyService.getAssociates,
                companyId
            );
            if (!fetchError) {
                if (caseId) {                
                    yield put(deleteCaseAssociates(caseId, [associateID], companyId));
                }
                // ("company_associates", company_associates);
                // yield put(updatedCompanyAssociates(companyId, company_associates));
            }
        }else{
            const prevAssociates = associates.filter(_ => _.id).map(_ => _.id);
            const { error: updateError  , data} = yield call(
                CompanyService.updateAssociates,
                companyId,
                associates.map(_ => _.formValues)
            );
            const createdAssociatesId = data.map(_ => _.id);
            if (!updateError) {
                const { data, error: fetchError } = yield call(
                    CompanyService.getAssociates,
                    companyId,
                    // caseId
                );
                // const { data: dataCaseAssociate, error: fetchErrors } = yield call(
                //     CompanyService.getCaseFilterAssociates,
                //     companyId,
                //     caseId
                // );
                if (!fetchError) {
                    if (addresses.length || addresses.size) {
                        yield* updateCompanyAddresses({
                            payload: {
                                companyId,
                                addresses: addresses.map((_) =>
                                    _.set("associate", _.associate || data[data.length-1].id).set("id", typeof _.get("id") == "string" ? null : _.id)
                                )
                            }
                        });
                    }
                    if (caseId) {
                        let company_associates = data.filter(_ => !prevAssociates.includes(_.id)).map(_ => {
                            return {
                                id: _.id,
                                type: _.type
                            };
                        });
                        let final_associates = company_associates.filter(associate => createdAssociatesId.includes(associate.id));

                        yield put(addCaseAssociates(caseId, final_associates, companyId));
                    }
                    // yield put(updatedCompanyAssociates(companyId, data));
                    // yield put(fetchCompanyProfile(companyId, caseId));
                    message.success("Associate Details Updated");
                }
            } else {
                yield put(failedUpdateCompanyAssociates(companyId, updateError));
                message.error("Failed to Upload Associate Details");
            }
        }
        
    } catch (error) {
        yield put(failedUpdateCompanyAssociates(companyId, error));
        message.error("Failed to Upload Associate Details");
    }
}

function* updateCompanySingleAssociate({ payload: { companyId, associate, address, fileObj, caseId , validateFromCompany} }) {
    try {
        const { data, error } = yield call(
            CompanyService.updateSingleAssociate,
            companyId,
            {...associate.formValues, case_id: caseId},
        );
        if (!error) {
            yield put(updatedCompanySingleAssociate(companyId, data));
            if (address) {
                yield put(updateCompanySingleAddress(companyId, address.set("associate", data.id).formValues, caseId));
            }
            if (fileObj) {
                yield put(attachDocument(fileObj.document && fileObj.document.id, caseId, {
                    case: caseId,
                    company: companyId,
                    file: fileObj.id,
                    document: fileObj.document && fileObj.document.id,
                    document_option : fileObj.document_option ? fileObj.document_option : null,
                    is_valid: true,
                    associate: data.id,
                    
                },{validateFromCompany : validateFromCompany }));
            }
            yield put(fetchApplicantsList(companyId));
            yield put(fetchCompanyProfile(companyId, caseId));
            message.success("Company Applicant Updated");
        } else {
            yield put(failedUpdateCompanySingleAssociate(companyId, error));
            message.error("Failed to Update Company Applicant");
        }
    } catch (error) {
        yield put(failedUpdateCompanySingleAssociate(companyId, error));
        message.error("Failed to Update Company Applicant");
    }
}

function* updateCompanyMultipleAssociate({ payload: { companyId, associate } }) {
    try {
        const { data, error } = yield call(
            CompanyService.updateMultipleAssociate,
            companyId,
            associate
        );
        if (!error) {
            yield put(updatedCompanyMultipleAssociate(companyId, data));
            yield put(fetchApplicantsList(companyId));
            yield put(fetchCompanyProfile(companyId, ""));
            message.success("Company Applicant Updated");
        } else {
            yield put(failedUpdateCompanyMultipleAssociate(companyId, error));
            message.error("Failed to Update Company Applicant");
        }
    } catch (error) {
        yield put(failedUpdateCompanyMultipleAssociate(companyId, error));
        message.error("Failed to Update Company Applicant");
    }
}


function* updateCompanySingleAddressHandler({ payload: { companyId, address ,case_id} }) {
    try {
        const { data, error } = yield call(
            CompanyService.updateSingleAddress,
            companyId,
            address,
            case_id
        );
        if (!error) {
            yield put(updatedCompanySingleAddress(companyId, data));
            message.success("Address Updated");
        } else {
            yield put(failedUpdateCompanySingleAddress(companyId, error));
            message.error("Failed to Update Address");
        }
    } catch (error) {
        yield put(failedUpdateCompanySingleAddress(companyId, error));
        message.error("Failed to Update Address");
    }
}

function* updateCompanySingleBankAccountHandler({ payload: { companyId, bankAccount } }) {
    try {
        const { data, error } = yield call(
            CompanyService.updateSingleBankAccount,
            companyId,
            {
                ...bankAccount,
                associate: bankAccount.associate === "company" ? null : bankAccount.associate
            }
        );
        if (!error) {
            yield put(updatedCompanySingleBankAccount(companyId, data));
            message.success("Bank Account Updated");
        } else {
            yield put(failedUpdateCompanySingleBankAccount(companyId, error));
            message.error("Failed to Update Bank Account");
        }
    } catch (error) {
        yield put(failedUpdateCompanySingleBankAccount(companyId, error));
        message.error("Failed to Update Bank Account");
    }
}

function* updateCompanyAddresses({ payload: { companyId, addresses } }) {
    try {
        const { data, error } = yield call(
            CompanyService.updateAddresses,
            companyId,
            addresses.map(_ => _.formValues),
        );
        if (!error) {
            yield put(updatedCompanyAddresses(companyId, data));
            message.success("Company Addresses Updated");
        } else {
            yield put(failedUpdateCompanyAddresses(companyId, error));
            message.error("Failed to Update Company Addresses");
        }
    } catch (error) {
        yield put(failedUpdateCompanyAddresses(companyId, error));
        message.error("Failed to Update Company Addresses");
    }
}

function* updateCompanyAddress({ payload: { companyId, type, address } }) {
    try {
        const { data, error } = yield call(
            CompanyService.updateAddresses,
            companyId,
            [address.formValues]
        );

        if (!error) {
            yield put(updatedCompanyAddress(companyId, type, data[0]));
            message.success("Company Address Updated");
        } else {
            yield put(failedUpdateCompanyAddress(companyId, type, error));
            message.error("Failed to Update Company Address");
        }
    } catch (error) {
        yield put(failedUpdateCompanyAddress(companyId, type, error));
        message.error("Failed to Update Company Address");
    }
}

function* updateAssociatesCibil({ payload: { associateId, cibil, companyId } }) {
    try {
        const { data, error } = yield call(CompanyService.updateAssociatesCibil, associateId, cibil);
        if (!error) {
            yield put(updatedCompanyAssociatesCibil(associateId, data, companyId));
            message.success("CIBIL updated Successfully");
            return;
        }
        yield put(failedUpdateCompanyAssociatesCibil(associateId, error, companyId));
        message.error("CIBIL Update Failed");
    } catch (error) {
        yield put(failedUpdateCompanyAssociatesCibil(associateId, error, companyId));
        message.error("CIBIL Update Failed");
    }
}


function* updateCompanyBankAccounts({ payload: { companyId, bankAccounts, caseId } }) {
    try {
        let accounts = bankAccounts.map(_ => {
            if (_.get("associate") === "company") {
                _.set("associate", null);
                return _;
            }
            return _;
        });
        const { data, error } = yield call(
            CompanyService.updateBankAccounts,
            companyId,
            accounts.map(_ => _.formValues)
        );
        if (!error) {
            message.success("Company Bank Accounts Updated");
            yield put(updatedCompanyBankAccounts(companyId, data));
            yield put(fetchCaseDetail(caseId));
        } else {
            yield put(failedUpdateCompanyBankAccounts(companyId, error));
            message.error("Failed to Update Company Bank Accounts");
        }
    } catch (error) {
        yield put(failedUpdateCompanyBankAccounts(companyId, error));
        message.error("Failed to Update Company Bank Accounts");
    }
}


function* fetchCompanyGstinFillingDetails({ payload: { gstin } }) {
    try {
        const { data, error } = yield call(CompanyService.getCompanyGstinFillingDetails, gstin);
        if (!error) {
            let newData = [];
            const keys = Object.keys(data);
            if (keys.length === 0) {
                newData = [];
            } else if (keys.reduce((agg, _) => /\d{4}-\d{2}/.test(_) && agg, true)) {
                (data, keys);
                if (data[keys[1]] && data[keys[1]].data.EFiledlist) {
                    newData = [
                        ...newData,
                        ...(data[keys[1]] && data[keys[1]].data.EFiledlist)
                    ];
                }
                if (data[keys[0]] && data[keys[0]].data.EFiledlist) {
                    newData = [
                        ...newData,
                        ...(data[keys[0]] && data[keys[0]].data.EFiledlist)
                    ];
                }
            } else {
                newData = [...data.data.EFiledlist];
            }
            yield put(fetchedCompanyGstinFillingDetails(gstin, newData));
        } else {
            yield put(failedFetchCompanyGstinFillingDetails(gstin, error));
        }
    } catch (error) {
        yield put(failedFetchCompanyGstinFillingDetails(gstin, error));
    }
}

function* refreshCompanyGstinFillingDetails({ payload: { gstin, companyId } }) {
    try {
        const { data, error } = yield call(CompanyService.refreshCompanyGstinFillingDetails, gstin);
        if (!error) {
            let newData = [];
            const keys = Object.keys(data);
            if (keys.length === 0) {
                newData = [];
            } else if (keys.reduce((agg, _) => /\d{4}-\d{2}/.test(_) && agg, true)) {
                newData = [...(data[keys[1]].data.EFiledlist), ...(data[keys[0]].data.EFiledlist)];
            } else {
                newData = [...data.data.EFiledlist];
            }

            yield put(refreshedCompanyGstinFillingDetails(gstin, newData));
            yield put(fetchCompanyProfile(companyId, ""));
            message.info("GSTIN Filling Information Updated");
        } else {
            yield put(failedRefreshCompanyGstinFillingDetails(gstin, error));
        }
    } catch (error) {
        yield put(failedRefreshCompanyGstinFillingDetails(gstin, error));
    }
}


function* fetchCompanyChecklist({payload : {companyId}}){
    try {
        const { data, error } = yield call(
            CompanyService.getCompanyChecklist,
            companyId,
        );
        if (!error) {
            yield put(fetchedCompanyChecklist(data));
        } else {
            yield put(failedFetchCompanyChecklist(error));
        }
    } catch (error) {
        yield put(failedFetchCompanyChecklist(error));
    }
}

function* fetchCompanyNotes({payload : {actionDetailId}}){
    try {
        const { data, error } = yield call(
            CompanyService.getCompanyNotes,
            actionDetailId,
        );
        if (!error) {
            yield put(fetchedCompanyNotes(data));
        } else {
            yield put(failedFetchCompanyNotes(error));
        }
    } catch (error) {
        yield put(failedFetchCompanyNotes(error));
    }
}

function* createCompanyNotes({payload : {companyNote}}){
    try {
        const { data, error } = yield call(CompanyService.createCompanyNote , companyNote);
        if (!error) {
            yield put(fetchedCreateCompanyNotes());
        } else {
            yield put(failedCreateCompanyNotes(error));
        }
    } catch (error) {
        yield put(failedCreateCompanyNotes(error));
    }
}

function* fetchCompanyAssociatesV2({payload : {caseId}}){
    try {
        const { data, error } = yield call(CompanyService.getCompanyAssociatesV2 , caseId);
        if (!error) {
            yield put(fetchedCompanyAssociatesV2(data));
        } else {
            yield put(failedFetchCompanyAssociatesV2(error));
        }
    } catch (error) {
        yield put(failedFetchCompanyAssociatesV2(error));
    }
}
function* updateMpaDetails({payload : {data, mpaId, loaderFor}}){
    try {
        const { error } = yield call(CompanyService.saveMpaDetails, data, mpaId);
        if (!error) {
            yield put(updatedMpaDetails(loaderFor));
        } else {
            yield put(failedUpdateMpaDetails(error));
        }
    } catch (error) {
        message.error(error.non_field_errors ? error.non_field_errors[0] : "Something Went Wrong");
        yield put(failedUpdateMpaDetails(error));
    }
}


function* fetchCompanyAllMpaDetails({payload : {companyId}}){
    try {
        const { data, error } = yield call(CompanyService.getCompanyAllMpa , companyId);
        if (!error) {
            yield put(fetchedCompanyAllMpa(data));
        } else {
            yield put(failedFetchCompanyAllMpa(error));
        }
    } catch (error) {
        yield put(failedFetchCompanyAllMpa(error));
    }
}

function* fetchAllEnums(){
    try {
        const { data, error } = yield call(CompanyService.getEnums);
        if (!error) {
            yield put(fetchedEnums(data));
        } else {
            yield put(failedFetchEnums(error));
        }
    } catch (error) {
        yield put(failedFetchEnums(error));
    }
}
function* fetchPanAadharLink({payload : {caseId, associateId}}){
    const hide = message.loading('PAN–Aadhaar linking in process...', 0);
    try {
        const body = { case_id: caseId, associate_id: associateId };
        const response = yield call(CompanyService.companyAadharPanLink , body);
        yield put(fetchedPanAadharLink(response.data));
        if (response.status === 200 || response.status === 201) {
            try {
                yield put(fetchCompanyAssociatesV2Action(caseId));
            } catch (error) {
                console.error("Error dispatching fetchCompanyAssociatesV2:", error);
            }
        }
        message.success("PAN–Aadhaar link completed successfully.");
    } 
    catch (error) {
        message.error('PAN–Aadhaar link failed.');
        yield put(failedFetchPanAadharLink(error));
    }finally {
        hide();
    }
}




export default fork(function* () {
    yield takeLatest(
        COMPANY_ACTIONS.FETCH_COMPANY_PROFILE,
        fetchCompanyProfileHandler
    );
    yield takeLatest(
        COMPANY_ACTIONS.UPDATE_COMPANY_PROFILE,
        updateCompanyProfile
    );
    yield takeLatest(
        COMPANY_ACTIONS.UPDATE_COMPANY_ASSOCIATES,
        updateCompanyAssociates
    );
    yield takeLatest(
        COMPANY_ACTIONS.UPDATE_COMPANY_ADDRESSES,
        updateCompanyAddresses
    );
    yield takeLatest(
        COMPANY_ACTIONS.UPDATE_COMPANY_ADDRESS,
        updateCompanyAddress
    );
    yield takeLatest(
        COMPANY_ACTIONS.UPDATE_COMPANY_BANK_ACCOUNTS,
        updateCompanyBankAccounts
    );
    yield takeLatest(
        COMPANY_ACTIONS.UPDATE_COMPANY_ASSOCIATES_CIBIL,
        updateAssociatesCibil
    );
    yield takeLatest(
        COMPANY_ACTIONS.UPDATE_COMPANY_SINGLE_ASSOCIATE,
        updateCompanySingleAssociate
    );
    yield takeLatest(
        COMPANY_ACTIONS.UPDATE_COMPANY_MULTIPLE_ASSOCIATE,
        updateCompanyMultipleAssociate
    );
    yield takeLatest(
        COMPANY_ACTIONS.UPDATE_COMPANY_SINGLE_ADDRESS,
        updateCompanySingleAddressHandler
    );
    yield takeLatest(
        COMPANY_ACTIONS.FETCH_COMPANY_GSTIN_FILLING_DETAILS,
        fetchCompanyGstinFillingDetails
    );
    yield takeLatest(
        COMPANY_ACTIONS.REFRESH_COMPANY_GSTIN_FILLING_DETAILS,
        refreshCompanyGstinFillingDetails
    );
    yield takeLatest(
        COMPANY_ACTIONS.UPDATE_COMPANY_SINGLE_BANK_ACCOUNT,
        updateCompanySingleBankAccountHandler
    );
    yield takeLatest(
        COMPANY_ACTIONS.FETCH_COMPANY_CHECKLIST,
        fetchCompanyChecklist
    );
    yield takeLatest(
        COMPANY_ACTIONS.FETCH_COMPANY_NOTES,
        fetchCompanyNotes
    );
    yield takeLatest(
        COMPANY_ACTIONS.CREATE_COMPANY_NOTE,
        createCompanyNotes
    );
    yield takeLatest(
        COMPANY_ACTIONS.FETCH_COMPANY_ASSOCIATES_V2,
        fetchCompanyAssociatesV2
    ),
    yield takeLatest(
        COMPANY_ACTIONS.UPDATE_MPA_DETAILS,
        updateMpaDetails
    )
    
    yield takeLatest(
        COMPANY_ACTIONS.FETCH_COMPANY_ALL_MPA,
        fetchCompanyAllMpaDetails
    )

    yield takeLatest(
        COMPANY_ACTIONS.FETCH_ENUMS,
        fetchAllEnums
    )

    yield takeLatest(
        COMPANY_ACTIONS.FETCH_PAN_AADHAR_LINK,
        fetchPanAadharLink
    )


});
